import { Heart } from "lucide-react";
import { Link } from "react-router";

import execWhiteLogo from "@/../../hypetrain/static/img/exec-wm-white.png";
import { APP_PROFILE } from "@/components/helpers/configuration/constants";
import { LazyImg } from "@/components/helpers/ui/LazyImg";
import { Container } from "@/components/pieces/bootstrap";
import { PUBLIC_CONTENT_MAX_WIDTH } from "@/css/constants";

export function ExecFooter() {
  const helloEmail = APP_PROFILE.helloEmail;

  return (
    <div className="bg-blue-950 pt-16 pb-8 text-white">
      <Container maxWidth={PUBLIC_CONTENT_MAX_WIDTH}>
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:gap-16">
          <div>
            <LazyImg
              style={{ marginBottom: 10 }}
              src={execWhiteLogo}
              width={150}
              className="inline-block"
            />
            <div className="mt-3 max-w-48 text-sm/relaxed font-semibold text-gray-400">
              <Heart
                className="mr-1 inline-block text-red-600"
                fill="currentColor"
                size={12}
              />
              Built in San Francisco
            </div>
          </div>
          <div>
            <div className="mb-3 font-bold">Platform & Resources</div>
            <ul className="flex flex-col gap-3">
              <li>
                <Link className="text-gray-400" to="/ai-roleplays">
                  AI Roleplays
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/learn">
                  Guides
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/sales-comp">
                  Sales Comp Calculator
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/faq">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <div className="mb-3 font-bold">Solutions</div>
            <ul className="flex flex-col gap-3">
              <li>
                <Link className="text-gray-400" to="/exec-development">
                  Executive Development
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/manager-growth">
                  Manager Growth
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/hipo-program">
                  High Potential Programs
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/offsites">
                  Offsites & Events
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/ai-roleplays">
                  AI Roleplays
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/for-individuals">
                  For Individuals
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/outplacement">
                  Outplacement
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <div className="mb-3 font-bold">Company</div>
            <ul className="flex flex-col gap-3">
              <li>
                <Link className="text-gray-400" to="/about-us">
                  About Us
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/for-coaches">
                  Join as Coach
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/enterprise-privacy">
                  Enterprise Privacy
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/privacy-policy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link className="text-gray-400" to="/tos">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <div className="mb-3 font-bold">Contact</div>
            <div className="text-sm text-gray-400">
              <div className="mb-4">
                <div className="font-semibold">Email Us:</div>
                <a className="text-blue-500" href={`mailto:${helloEmail}`}>
                  {helloEmail}
                </a>
              </div>
              <div className="mb-2 font-semibold">
                Mailing Address (PO Box):
              </div>
              <div>
                440 N Barranca Ave #1890
                <br />
                Covina, CA 91723
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-blue-900 pt-8 lg:flex-row lg:gap-0">
          <div className="text-sm text-gray-400">
            ©{new Date().getFullYear()} Exec Holdings, Inc. All rights reserved.
          </div>
        </div>
      </Container>
    </div>
  );
}
